import React from "react";
// import Modal from "../components/Modal.jsx";
// import { Link, Route } from 'react-router-dom'
import { domain, headers, settings } from '../Variables'
import { modules, pagesData } from '../PagesData'
import Container from '../components/Container'
import ModuleBox from '../components/Boxes/Module'
import { allNames } from '../Variables'
// var distanceInWordsToNow = require('date-fns/distance_in_words_to_now')
import Cookies from 'universal-cookie';
const cookies = new Cookies();


class Dashboard extends React.Component {

  state = {
    showModal: false,

    modules: [],

    basicSelectedIndex: null,
    senarioSelectedIndex: 0

  }

  componentWillMount() {
    // this.setState({ modules })
    document.title = settings.siteName + ' داشبورد'
    this.fetch()
  }


  fetch() {

    // let body = { "headers": this.state.itemsList , title:'test',description:'this is test desc'}

    fetch(domain + '/modules/getAll', {
      method: 'POST',
      body: JSON.stringify({}),
      headers: headers
    })

      .then(response => response.json()).then(data => {
        if (data.status == 200) {

          // console.log(data)
          this.setState({ modules: data.info })
        }

      }).catch(error => this.setState({ error, isLoading: false }));
  }


  checkPermission(applet) {

    let role = cookies.get('role')

    if (allNames.englishName == 'gamas20.ir') {
      if (role != 'editor' || applet == 'questions') {
        return true
      }
    }



    if (role == 'editor' && applet == 'settings') {
      return false
    } else {
      return true
    }

  }


  render() {
    return (



      <div className=" mediumiransansfont" style={{}}>

        <Container modules={this.props.modules} isOpen={true} modalIsOpen={false} location={this.props.location} >

          <div style={{ paddingRight: '6%', paddingLeft: '6%', }}>

            <div className="row" style={{ marginBottom: 20 }}>

              <div className={'col-12 d-flex align-items-center p-0'} style={{ marginBottom: 20 }}>
                <div style={{ width: '100%', backgroundColor: '#fff', padding: 20, paddingRight: 30, marginLeft: 0, display: 'flex', borderRadius: 20, boxShadow: '0px 0px 30px rgba(50,60,70,0.1)' }}>

                  {/* <div style={{ backgroundColor: '#fff', borderRadius: 50, width: 120, padding: 10, marginLeft: 20 }}>
                    <img style={{ width: '100%' }} src="/images/logo.png" />
                  </div> */}
                  <div>
                    <p style={{ fontSize: 25, marginBottom: 0, marginBottom: 0, marginTop: 0, color: '#000', marginRight: 0, fontWeight: 'bold' }}>سامانه {allNames.persianName}</p>
                    <p style={{ fontSize: 12, letterSpacing: 0, marginBottom: 0, marginTop: 0, color: '#000', marginRight: 0 }}>مــاژول هـای سیســتم</p>
                  </div>
                </div>
              </div>
              {/* onClick={() => this.props.history.push('/page/'+prop.page)} */}
              {this.state.modules.map((prop, index) => {
                // if()
                if (this.checkPermission(prop.applet)) {
                  return (
                    <ModuleBox data={prop} />
                  )
                }
              })}

              {/* <ModuleBox data={{ customPage: '/formbuilder/add', title: 'افزودن لیست', description: 'Admin Settings' }} /> */}
              {(this.checkPermission("settings")) && (
                <ModuleBox data={{ customPage: '/settings', title: 'تنظیمات', description: 'Admin Settings' }} />
              )}

              

              {/* <div className={'col-12 d-flex align-items-center mt-5'} style={{ marginBottom: 20 }}>
            <div>
              <p style={{ fontSize: 18, marginBottom: 0, marginBottom: 0, marginTop: 0, color: '#000', marginRight: 0 }}>WIDGETS</p>
              <p style={{ fontSize: 12, letterSpacing: 3, marginBottom: 0, marginTop: 0, color: '#ccc', marginRight: 0 }}>SYSTEM WIDGETS</p>
            </div>
          </div> */}
            </div>
          </div>
        </Container>

      </div>
    );
  }
}

export default Dashboard;
